import * as React from "react";
import { Link } from "react-router-dom";

import style from "./style";

import { TabProps } from "./Tabs.d";
import { Cell } from "../Grid";

const Tab: React.FC<TabProps> = ({
  vertical = false,
  active = false,
  currentTab = false,
  name = "",
  className="",
  onClick = () => null,
  href = "#",
  children,
}) => {
  const activeTabStyle = vertical ? style.tabActiveVertical : style.tabActive;
  let isActive = active ? activeTabStyle : null;
  isActive = currentTab === name ? activeTabStyle : isActive;

  return (
    <Link onClick={onClick} to={href}>
      <Cell style={{ ...style.tab, ...isActive }} className={className}>{children}</Cell>
    </Link>
  );
};

export default Tab;
